import axios from 'axios';

const API_KEY = process.env.REACT_APP_API_KEY || 'tu-api-key-aqui';

const client = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://claudio.trading',
  timeout: 10000,
  headers: {
    'X-API-Key': 'X7k#mP9@qR2nL5vW',
  },
});

export const api = {
    // Agent
    getStatus: () => client.get('/api/agent/status'),
    getAccount: () => client.get('/api/agent/account'),
    getPositions: () => client.get('/api/agent/positions'),
    pauseAgent: () => client.post('/api/agent/pause'),
    resumeAgent: () => client.post('/api/agent/resume'),

    // Strategies
    getStrategies: () => client.get('/api/gym/strategies'),
    toggleStrategy: (id) => client.put(`/api/gym/strategies/${id}/toggle`),
    updateStrategy: (id, data) => client.put(`/api/gym/strategies/${id}`, data),

    // Decisions
    getDecisions: (params) => client.get('/api/agent/decisions', { params }),

    // Trades
    getTrades: (params) => client.get('/api/agent/trades', { params }),
	
	getGymData: () => client.get('/api/gym/data'),
	getBacktestResults: (params) => client.get('/api/gym/results', { params }),
	runBacktest:        (data)   => client.post('/api/gym/backtest', data),
	getBacktestDetail:  (id)     => client.get(`/api/gym/results/${id}`),
};

export default client;